export default __webpack_public_path__ + "static/logo-ba526d84f00fe17fde7605cea8d9ed2e.png";